import React, { ReactNode } from 'react';
import { WithTestId } from '../../../types';
import { toKebabCase } from '../../../utils';
import styles from './textButton.module.css';

export interface TextButtonProps extends WithTestId {
  onClick?: () => void;
  children: ReactNode;
}

const TextButton = ({
  onClick,
  children,
  dataTestIdPrefix,
}: TextButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={styles.textButton}
      data-testid={toKebabCase(dataTestIdPrefix, 'textButton')}
    >
      {children}
    </button>
  );
};

export default TextButton;
